export const SET_PURCHASE = "SET_PURCHASE";
export const RESET_PURCHASE = "RESET_PURCHASE";
export const SET_SPECIFIC_PURCHASE = "SET_SPECIFIC_PURCHASE";
export const RESET_SPECIFIC_PURCHASE = "RESET_SPECIFIC_PURCHASE";
export const SET_PURCHASE_REPORT = "SET_PURCHASE_REPORT";
export const SET_UNPAID_POSTED_PURCHASES = "SET_UNPAID_POSTED_PURCHASES";
